module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><legend>'+
((__t=( i18n.tc("LegacyLogin", "Log in with credentials from hyttami.no") ))==null?'':__t)+
'</legend><div><label for="legacy-username-input">'+
((__t=( i18n.tc("LegacyLogin", "Subscription no. / Username:") ))==null?'':__t)+
'</label> <input type="text" id="legacy-username-input" data-input="legacy-user" value="" required></div><div><label for="legacy-password-input">'+
((__t=( i18n.tc("LegacyLogin", "PIN-code / Password:") ))==null?'':__t)+
'</label> <input type="password" id="legacy-password-input" data-input="legacy-password" '+
((__t=( isTechSupport ? " disabled " : " required" ))==null?'':__t)+
'></div></fieldset><fieldset class="button-wrap"><button data-click="legacy-cancel">'+
((__t=( i18n.tc("LegacyLogin", "Cancel") ))==null?'':__t)+
'</button> <button class="primary" data-click="legacy-submit" disabled="disabled">'+
((__t=( i18n.tc("LegacyLogin", "Continue") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
